import React, { Component } from 'react';
import { dateWithFormatOrNa, toUSD } from '../helpers/formatters';

// Import assets
import scheduledImg from '../assets/images/scheduled.png';

// Import assets
import paidOffImg from '../assets/images/paid-off.png';

// Import styles
import '../styles/modules/load-account.css';

class LoanAccount extends Component {

 

  /**
   * Render the last and next payments information.
   */
  renderLastAndNextPayments() {
    let { selectedLoanAccount } = this.props;

    return (
      <div className="flex-block flex-block--space-between">
        {/* Last Payment */}
        <div className="line-height-15">
          <span className="money money--block">{toUSD(selectedLoanAccount.lastPmtAmt)}</span>
          <span className="load-account__money-legend">{this.props.whiteLabel.labels['Last Payment']}</span>
          <span className="load-account__money-date">
            {
              selectedLoanAccount.lastPmtDt 
              ? dateWithFormatOrNa(selectedLoanAccount.lastPmtDt.date) 
              : 'N/A'
            }
          </span>
        </div>

        {/* Next Payment */}
        <div className="align-right line-height-15">
          { 
            selectedLoanAccount.daysPastDue > 0 
            ? <span className="money money--block money--red">
                { toUSD(selectedLoanAccount.totalAmtDue) }
              </span>
            : <span className="money money--block money--green">
                { toUSD(selectedLoanAccount.calNextPayment) }
              </span>
          }
          <span className="load-account__money-legend">{this.props.whiteLabel.labels['Next Payment']}</span>
          <span className="load-account__money-date">
            { 
              selectedLoanAccount.newOldestDate 
              ? dateWithFormatOrNa(selectedLoanAccount.newOldestDate.date) 
              : 'N/A'
            }
          </span>
        </div>
      </div>
    );
  }

  /**
   * Render the component view.
   */
  render() {
    let { selectedLoanAccount } = this.props;

    if (!selectedLoanAccount) {
      return null;
    }

    return (
      <div className="loan-account">
        {this.props.header}

        <div className="card">
          {this.props.collateral}

          <div>
            {this.props.profile}

            <div className="load-account__payment-data-wrapper">
              <div className="load-account__profile">
                <h5 className="loan-account__borrower">
                  { (selectedLoanAccount.isBorrower)
                      ? `${selectedLoanAccount.borrower.firstName} ${selectedLoanAccount.borrower.lastName}`
                      : `${selectedLoanAccount.borrower.coBorrower.firstName} ${selectedLoanAccount.borrower.coBorrower.lastName}`
                  }
                </h5>
                {(selectedLoanAccount.loanPayOffBalance == 0 && this.props.paidOff === true)
                  ? <img className="loan-account__impress" src={paidOffImg} alt="" />
                  : null
                }
                { (selectedLoanAccount.hasScheduled)
                  ? <img className="loan-account__impress" src={scheduledImg} alt="" />
                  : null
                }
              </div>

              {/**
                ** Last payment & Next payment.
                **/}
              {
                (this.props.hideLastNextPmtInfo) ? null : this.renderLastAndNextPayments()
              }

              {/**
                ** Render the payment or schedule Form.
                **/}
              {this.props.children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LoanAccount;


// WEBPACK FOOTER //
// ./src/containers/loan-account.js